import { useCallback, useMemo } from 'react';
import Combobox from '@ls/react-combobox-grid';
import SelectionState from 'state/selections/SelectionState';
import { useDispatch, useSelector } from 'react-redux';
import { setSecurityLabel } from 'state/selections/actions';
import { selectSecurityLabel } from 'state/selections/selectors';
import {
  selectFetchingSecurityAttributesOptions,
  selectSecurityAttributesOptions,
} from 'state/securityAttributes/selectors';
import { compareValues } from '@ls/js-utils';
import { card } from 'components/Card';
import styled from 'styled-components';

const Card = styled.div`
  ${card}
  background: rgba(208, 208, 208, 0.75);
  padding: 5px;
`;

const SecurityLabelSelector = props => {
  const dispatch = useDispatch();
  const loading = useSelector(selectFetchingSecurityAttributesOptions);
  const securityAttributesOptions = useSelector(selectSecurityAttributesOptions);
  const value = useSelector(selectSecurityLabel(SelectionState.UNCOMMITTED));

  const options = useMemo(() => {
    return securityAttributesOptions?.map(value => ({ label: value, value: value }))?.sort(compareValues('label')) ?? [];
  }, [securityAttributesOptions]);

  const onChange = useCallback((label) => {
    dispatch(setSecurityLabel(label));
  }, [dispatch]);

  return (
    <Card>
      <div title='Optional security attribute field for overriding default security labels.'>
        <Combobox
          options={options}
          onChange={onChange}
          value={value}
          loading={loading}
          clearable={true}
          closeOnSelect
          multi={false}
          label="Security Label:"
          placeholder={"(Default)"}
          tooltip={"Optional security attribute field for overriding default security labels."}
        />
      </div>
    </Card>
  );
};

export default SecurityLabelSelector;
